<ng-container *ngIf="buttons$ | async as list">
    <ng-container *ngIf="list.length">
        <ng-container *ngIf="list?.length === 1; else elseTemplate">
            <fui-button
                [title]="list[0]?.title"
                (clickEvent)="$event.stopPropagation(); buttonClick.emit({ name: list[0]?.click })"
                [color]="buttonConf?.color"
                [icon]="list[0]?.icon ?? buttonConf?.icon"
                [height]="buttonConf?.height"
                [borderRadius]="buttonConf?.borderRadius"
                type="button-icon"
            >
            </fui-button>
        </ng-container>
    </ng-container>
    <ng-template #elseTemplate>
        <fui-button
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="addMenu"
            [matMenuTriggerData]="{ list }"
            [color]="buttonConf?.color"
            [icon]="buttonConf?.icon"
            [height]="buttonConf?.height"
            [borderRadius]="buttonConf?.borderRadius"
            type="button-icon"
        >
        </fui-button>
    </ng-template>
</ng-container>
<mat-menu #addMenu="matMenu">
    <ng-template matMenuContent let-list="list">
        <ng-container *ngFor="let item of list">
            <button
                (click)="buttonClick.emit({ name: item?.click })"
                [disabled]="item.disabled"
                mat-menu-item
                class="context-menu-item"
            >
                {{ item.label }}
            </button>
        </ng-container>
    </ng-template>
</mat-menu>
